import React from "react";
import { CustomChip } from "../../../../shared/components/chips/CustomChip";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { PriorityTypeCode } from "../../models/models";

export interface PriorityChipProps {
  value?: PriorityTypeCode;
}

const PriorityChip = ({ value }: PriorityChipProps) => {
  const { translate } = useTranslation(["servicing", "common"]);

  const priorities = {
    [PriorityTypeCode.urgent]: { nameKey: "servicing:priorities.urgent", color: "#F23E3E", background: "#FEF1F1" },
    [PriorityTypeCode.high]: { nameKey: "servicing:priorities.high", color: "#FF733E", background: "#FFF4F0" },
    [PriorityTypeCode.low]: { nameKey: "servicing:priorities.low", color: "#40978A", background: "#F4FAFA" },
  };

  const priority = priorities[value || PriorityTypeCode.low];

  return (
    <CustomChip
      value={translate(priority.nameKey)}
      sx={{ color: priority.color, background: priority.background }}
    />
  );
};

export default PriorityChip;
